<template>
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.41016 11.4023C3.41016 10.4499 3.52832 9.69076 3.76465 9.125C4.00098 8.55924 4.46647 7.93978 5.16113 7.2666C5.86296 6.58626 6.30697 6.10286 6.49316 5.81641C6.77962 5.37956 6.92285 4.9069 6.92285 4.39844C6.92285 3.72526 6.75456 3.21322 6.41797 2.8623C6.08854 2.50423 5.60156 2.3252 4.95703 2.3252C4.34115 2.3252 3.84342 2.50065 3.46387 2.85156C3.09147 3.19531 2.90527 3.66439 2.90527 4.25879H0.294922C0.309245 2.99121 0.738932 1.98861 1.58398 1.25098C2.4362 0.513346 3.56055 0.144531 4.95703 0.144531C6.39648 0.144531 7.51725 0.509766 8.31934 1.24023C9.12858 1.9707 9.5332 2.99121 9.5332 4.30176C9.5332 5.46908 8.98893 6.61849 7.90039 7.75L6.5791 9.0498C6.10645 9.58691 5.86296 10.3711 5.84863 11.4023H3.41016ZM3.22754 14.7432C3.22754 14.3206 3.36003 13.9805 3.625 13.7227C3.88997 13.4577 4.24805 13.3252 4.69922 13.3252C5.15755 13.3252 5.51921 13.4613 5.78418 13.7334C6.04915 13.9984 6.18164 14.335 6.18164 14.7432C6.18164 15.137 6.05273 15.4665 5.79492 15.7314C5.53711 15.9964 5.17188 16.1289 4.69922 16.1289C4.22656 16.1289 3.86133 15.9964 3.60352 15.7314C3.35286 15.4665 3.22754 15.137 3.22754 14.7432Z"
      fill="#778493"
    />
  </svg>
</template>

<script>
export default {
  name: 'Questionmark'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
